import React, { useState } from 'react'

import { useAccounts } from '@/core/hooks/account/useAccounts'
import { useAccountConfig } from '@/core/hooks/useAccountConfig'
import { useTranslation } from '@/core/i18n/useTranslation'
import { SearchableSelector } from '@/shared/components/molecules/SearchableSelector/SearchableSelector'

const PAGE_SIZE = 25

interface AccountFilterDropdownProps {
	value: number | null
	onChange: (id: number | null) => void
}

export const AccountFilterDropdown: React.FC<AccountFilterDropdownProps> = ({
	value,
	onChange,
}) => {
	const { t } = useTranslation('zones')
	const [searchQuery, setSearchQuery] = useState('')
	const [page, setPage] = useState(1)

	const { data, isLoading } = useAccounts({
		config: useAccountConfig({
			params: {
				query: searchQuery || undefined,
				page,
				per_page: PAGE_SIZE,
			},
		}),
	})

	const items = (data?.data ?? []).map((a) => ({ id: a.id, label: a.name }))
	const totalPages = data?.meta?.pagination?.total_pages ?? 1

	const handleSearchChange = (query: string) => {
		setSearchQuery(query)
		setPage(1)
	}

	return (
		<SearchableSelector
			items={items}
			value={value}
			onChange={(id) => onChange(id as number | null)}
			onSearchChange={handleSearchChange}
			isLoading={isLoading}
			allOptionLabel={t('accountFilter.placeholder')}
			searchPlaceholder={t('accountFilter.search')}
			noResultsText={t('accountFilter.noResults')}
			page={page}
			totalPages={totalPages}
			onPageChange={setPage}
		/>
	)
}
